import React, { useState, useEffect, useContext } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import TimeFields from './PosterForm/TimeFields'
import { CityContext } from '../../../context/City';
import { PosterCategoriesContext } from '../../../context/PosterCategories';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ru } from 'date-fns/locale';

registerLocale('ru', ru);

const PosterForm = ({ poster, onSubmit, resetCurrentPoster }) => {
    const { citiesAdd } = useContext(CityContext)
    const { categories } = useContext(PosterCategoriesContext)
    const [valImages, setValImages] = useState(false)
    const [valPreview, setValPreview] = useState(false)
    const [valImagesZero, setValImagesZero] = useState(false)

    const { register, control, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        defaultValues: poster || {
            timetable: [{
                year: new Date().getFullYear(),
                day: new Date().getDate(),
                month: new Date().getMonth() + 1,
                time: [{ time: '', price: '' }]
            }],
            preview: null,
            images: [],
            categories: [],
            idCity: null
        }
    });

    const [previewFileName, setPreviewFileName] = useState('');
    const [imageFileNames, setImageFileNames] = useState([]);


    const { fields: timetableFields, append: appendTimetable, remove: removeTimetable, update: updateTimetable } = useFieldArray({
        control,
        name: 'timetable',
    });

    const { fields: imageFields, append: appendImage, remove: removeImage } = useFieldArray({
        control,
        name: 'images',
    });

    const { fields: categoryFields, append: appendCategory, remove: removeCategory } = useFieldArray({
        control,
        name: 'categories',
    });

    const handlePreviewFileChange = (event) => {
        const file = event.target.files[0];
        setValPreview(false)
        if (file) {
            setPreviewFileName(file.name);
            setValue("preview", file);
        } else {
            setPreviewFileName('');
            setValue("preview", null);
        }
    };

    const handleImageChange = (index) => (event) => {
        const file = event.target.files[0];
        setValImages(false)
        setValImagesZero(false)
        if (file) {
            setValue(`images.${index}`, file);


            const updatedFileNames = [...imageFileNames];
            updatedFileNames[index] = file.name;
            setImageFileNames(updatedFileNames);
        }
    };

    const addImageField = () => {
        appendImage();
        setImageFileNames((prev) => [...prev, '']);
    };

    useEffect(() => {
        reset(poster);
        if (poster?.preview) {
            setPreviewFileName(poster.preview.name);
            setValue("preview", poster.preview);
        }
        if (poster?.images) {
            setImageFileNames(poster.images.map(file => file.name));
        }

    }, [poster, reset, setValue]);

    const handleDateChange = (index) => (date) => {
        const selectedDate = new Date(date);
        const newdata = { year: selectedDate.getFullYear(), day: selectedDate.getDate(), month: selectedDate.getMonth() + 1 }
        setValue(`timetable.${index}.time`, [{ time: "", price: "" }])
        updateTimetable(index, newdata)
    };

    const addTimetableEntry = () => {
        appendTimetable({
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate(),
            time: [{ time: '', price: '' }]
        });
    };

    const handleCancelEdit = () => {
        resetCurrentPoster()
        reset(
            {
                posterName: '',
                posterDescription: '',
                price: '',
                email: '',
                phone: '',
                vkLink: '',
                webLink: '',
                venueName: '',
                keyword: '',
                instagramLink: '',
                shortPosterDescription: '',
                webLinkTimetable: '',
                address: { description: '', latitude: null, longitude: null },
                categories: [],
                images: [],
                preview: null,
                idCity: null,
                timetable: [{
                    year: new Date().getFullYear(),
                    day: new Date().getDate(),
                    month: new Date().getMonth() + 1,
                    time: [{ time: '', price: '' }]
                }],
            }
        );
        setImageFileNames([])
        setPreviewFileName('')
        setValImagesZero(false)
        setValPreview(false)
        setValImages(false)
    }
    const submitHandler = async (data) => {

        data.idCity = Number(data.idCity);
        data.categories = data.categories.map(id => ({
            idCategory: Number(id.idCategory),
            categoryName: categories.find(cat => cat.idCategory === Number(id.idCategory))?.categoryName || '',
            categoryRoute: categories.find(cat => cat.idCategory === Number(id.idCategory))?.categoryRoute || ''
        }));
        if (poster) {
            data.address.idVenue = poster.address.idVenue
        } else {
            data.address.idVenue = null
        }
        if (!data.address.latitude) {
            data.address.latitude = null
        } else {
            data.address.latitude = Number(data.address.latitude)
        }
        if (!data.address.longitude) {
            data.address.longitude = null
        } else {
            data.address.longitude = Number(data.address.longitude)
        }

        try {
            const formData = new FormData();
            data.idPoster && formData.append('idPoster', data.idPoster);


            formData.append('posterName', data.posterName);
            formData.append('posterDescription', data.posterDescription);
            formData.append('price', data.price);
            formData.append('email', data.email);
            formData.append('phone', data.phone);
            formData.append('vkLink', data.vkLink);
            formData.append('instagramLink', data.instagramLink);
            formData.append('webLink', data.webLink);
            formData.append('venueName', data.venueName);
            formData.append('keyword', data.keyword);
            formData.append('shortPosterDescription', data.shortPosterDescription);
            formData.append('webLinkTimetable', data.webLinkTimetable);

            formData.append('address', JSON.stringify(data.address));
            formData.append('categories', JSON.stringify(data.categories));
            formData.append('idCity', data.idCity);


            if (data.images && data.images.length > 0) {
                setValImagesZero(false);

                // Инициализируем массив для imageUrls
                const imageUrls = [];

                await Promise.all(data.images.map(async (image) => {
                    if (image instanceof File) {
                        formData.append('images', image);
                        setValImages(false);
                    } else if (image?.url) {
                        // Добавляем URL в массив
                        imageUrls.push(image); // Предполагается, что image.url содержит строку URL
                        setValImages(false);
                    } else {
                        setValImages(true);
                        return;
                    }
                }));

                formData.append('imageUrls', JSON.stringify(imageUrls));
            } else {
                setValImagesZero(true);
                return;
            }
            if (!formData.has('images')) {
                formData.append('images', null);
            }

            if (!formData.has('imageUrls')) {
                formData.append('imageUrls', null);
            }

            if (data.preview instanceof File) {
                formData.append('previewFile', data.preview);
                formData.append('previewUrl', null);
                setValPreview(false)
            } else if (data.preview?.url) {
                formData.append('previewUrl', JSON.stringify(data.preview));
                formData.append('previewFile', null);
                setValPreview(false)
            } else {
                setValPreview(true)
                return
            }

            formData.append('timetable', JSON.stringify(data.timetable));

            await onSubmit(formData);
            handleCancelEdit()

        } catch (error) {
            console.error("Ошибка при отправке данных:", error);
        }
    };

    return (
        <>
            {poster &&
                <div className="manager__cancel">
                    <p>Идет редактирование</p>
                    <button className='manager__button' onClick={handleCancelEdit}>Отмена</button>
                </div>
            }
            <form className='form' onSubmit={handleSubmit(submitHandler)}>
                <div className="form__item">
                    <label htmlFor="posterName">Название</label>
                    <div>
                        <input
                            id="posterName"
                            {...register("posterName", { required: "Это поле обязательно" })}
                        />
                        {errors.posterName && <span>{errors.posterName.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="idCity">Город</label>
                    <div>
                        <select id="idCity" {...register("idCity", { required: "Выберите город" })}>
                            {citiesAdd.map(city => (
                                <option key={city.id} value={city.id}>{city.name}</option>
                            ))}
                        </select>
                        {errors.idCity && <span>{errors.idCity.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label>Выберите категории</label>
                    <div className='form__verticalInputs'>
                        {categoryFields.map((item, index) => (
                            <div key={item.id} className="categoryInput">
                                <select {...register(`categories.${index}.idCategory`, { required: "Это поле обязательно" })}>
                                    {categories.map(category => (
                                        <option key={category.idCategory} value={category.idCategory}>
                                            {category.categoryName}
                                        </option>
                                    ))}
                                </select>
                                <button type="button" onClick={() => removeCategory(index)}>Удалить категорию</button>
                            </div>
                        ))}
                        <button type="button" onClick={() => appendCategory({ idCategory: '' })}>Добавить категорию</button>
                    </div>
                </div>


                <div className="form__item">
                    <label htmlFor="preview">Превью (вертикальное изображение)</label>
                    <input
                        type='file'
                        id="preview"
                        {...register("preview")}
                        onChange={handlePreviewFileChange}
                        style={{ display: 'none' }}
                    />
                    <div className='fileInput'>
                        <button type="button" onClick={() => document.getElementById('preview').click()}>
                            Выбрать файл
                        </button>
                        {previewFileName && <p>{previewFileName}</p>}
                        {errors.preview && <span>{errors.preview.message}</span>}
                        {valPreview && <p>Это поле обязательно</p>}
                    </div>
                </div>

                <div className="form__item">
                    <label>Изображения (горизонтальные)</label>
                    <div className="form__verticalInputs">
                        {imageFields.map((item, index) => (
                            <div key={item.id} className="imageInput">
                                <input
                                    type='file'
                                    id={`image-${index}`}
                                    {...register(`images.${index}`)}
                                    onChange={handleImageChange(index)}
                                    style={{ display: 'none' }}
                                />
                                <div className='fileInput'>
                                    <button type="button" onClick={() => document.getElementById(`image-${index}`).click()}>
                                        Выбрать файл
                                    </button>
                                    {imageFileNames[index] && <p>{imageFileNames[index]}</p>}
                                    {errors.images?.[index] && <span>{errors.images[index].message}</span>}
                                    {valImages && <p>Это поле обязательно</p>}
                                </div>
                                <button type="button" onClick={() => removeImage(index)}>Удалить изображение</button>
                            </div>
                        ))}
                        <button type="button" onClick={addImageField}>Добавить изображение</button>
                        {valImagesZero && <p>Это поле обязательно</p>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="price">Цена (строка)</label>
                    <div>
                        <input
                            id="price"
                            {...register("price", { required: "Это поле обязательно" })}
                        />
                        {errors.price && <span>{errors.price.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="keyword">Ключевые слова (через запятую)</label>
                    <div>
                        <input
                            id="keyword"
                            {...register("keyword")}
                        />
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="shortPosterDescription">Краткое описание постера</label>
                    <div>
                        <textarea
                            id="shortPosterDescription"
                            {...register("shortPosterDescription", { required: "Это поле обязательно" })}
                        />
                        {errors.shortPosterDescription && <span>{errors.shortPosterDescription.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="posterDescription">Полное описание постера</label>
                    <div>
                        <textarea
                            id="posterDescription"
                            {...register("posterDescription", { required: "Это поле обязательно" })}
                        />
                        {errors.posterDescription && <span>{errors.posterDescription.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="email">Email</label>
                    <div>
                        <input
                            type="email"
                            id="email"
                            {...register("email")}
                        />
                        {errors.email && <span>{errors.email.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="phone">Телефон</label>
                    <div>
                        <input
                            id="phone"
                            {...register("phone")}
                        />
                        {errors.phone && <span>{errors.phone.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="venueName">Название места</label>
                    <div>
                        <input
                            id="venueName"
                            {...register("venueName", { required: "Это поле обязательно" })}
                        />
                        {errors.venueName && <span>{errors.venueName.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="address.description">Адрес</label>
                    <div>
                        <input
                            id="address.description"
                            {...register("address.description")}
                        />
                        {errors.address?.description && <span>{errors.address.description.message}</span>}
                    </div>
                </div>

                {/* Поля для координат */}
                <div className="form__item">
                    <label htmlFor="address.latitude">Широта</label>
                    <div>
                        <input
                            id="address.latitude"
                            {...register("address.latitude")}
                        />
                        {errors.address?.latitude && <span>{errors.address.latitude.message}</span>}
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="address.longitude">Долгота</label>
                    <div>
                        <input
                            id="address.longitude"
                            {...register("address.longitude")}
                        />
                        {errors.address?.longitude && <span>{errors.address.longitude.message}</span>}
                    </div>
                </div>

                {/* Ссылки на социальные сети и веб-сайты */}
                <div className="form__item">
                    <label htmlFor="vkLink">Ссылка на VK</label>
                    <div>
                        <input
                            id="vkLink"
                            {...register("vkLink")}
                        />
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="instagramLink">Ссылка на Instagram</label>
                    <div>
                        <input
                            id="instagramLink"
                            {...register("instagramLink")}
                        />
                    </div>
                </div>


                <div className="form__item">
                    <label htmlFor="webLink">Веб-сайт</label>
                    <div>
                        <input
                            id="webLink"
                            {...register("webLink")}
                        />
                    </div>
                </div>

                <div className="form__item">
                    <label htmlFor="webLinkTimetable">Ссылка для расписания</label>
                    <div>
                        <input
                            id="webLinkTimetable"
                            {...register("webLinkTimetable", { required: "Это поле обязательно" })}
                        />
                        {errors.webLinkTimetable && <span>{errors.webLinkTimetable.message}</span>}
                    </div>
                </div>



                <h3>Расписание</h3>
                {timetableFields.map((item, index) => (
                    <div key={index} className="timetable__item">
                        <div>
                            <label>Дата:</label>
                            <DatePicker
                                selected={new Date(item.year || new Date().getFullYear(), (item.month && item.month - 1), item.day || new Date().getDate())} // Используем значения из полей
                                onChange={handleDateChange(index)}
                                locale="ru"
                                dateFormat="dd.MM.yyyy"

                            />
                            <button type="button" onClick={() => removeTimetable(index)}>Удалить</button>
                        </div>

                        <h4>Время</h4>
                        <TimeFields control={control} index={index} register={register} errors={errors} />
                        <button type="button" onClick={() => removeTimetable(index)}>Удалить день</button>
                    </div>
                ))}
                <button type="button" onClick={addTimetableEntry}>
                    Добавить день
                </button>


                <button className="form__button_save" type="submit">Сохранить</button>
            </form>
        </>
    );
};

export default PosterForm;